<template>
    <div>
        <el-dialog
                title="服务评价"
                :visible.sync="show"
                width="600px"
                >
            <div v-loading="loading">
                <div class="w100 pl20 pr20">
                    <div style="text-align: center;padding-bottom: 20px" v-if="form.score">
                        <img class="w100" style="width: 50px;"
                             :src="`${baseUrl}images/face${form.score}.png`">
                    </div>
                    <el-form label-width="120px" :model="form" :rules="rules"
                             ref="ruleForm" class="demo-form-inline">


                        <el-form-item  label="整体满意度"  >
                            <div class="pt5">
                                <el-rate v-model="form.score" @change="rateChange"></el-rate>
                                <div class="pt20 evaluate-type" >
                                    <el-checkbox-group v-if="form.score" v-model="checkedTypeArr">
                                        <el-checkbox v-for="item in typeVoList"
                                                     :label="item.id"
                                                     :key="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="评价内容" prop="content">
                            <el-input rows="5" v-model="form.content"
                                     type="textarea" placeholder="请入其他想说的评价"></el-input>
                        </el-form-item>
                        <el-form-item label="附件上传" prop="iconId" >
                            <el-upload

                                    class="upload-demo"
                                    action="#"
                                    :file-list="filelist"
                                    :before-remove="beforeRemove"
                                    :before-upload="beforeUpload"
                            >
                                <el-button  v-if="filelist.length==0" slot="trigger">
                                    <i class="el-icon-upload"></i>
                                </el-button>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="是否公开评论" prop="privateFlag" s>
                            <el-radio-group v-model="form.privateFlag">
                                <el-radio :label="0">匿名评价</el-radio>
                                <el-radio :label="1">允许公开</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        serveEvaluateTypeVoList,
        handleServeEvaluate
    } from '@/api/serveCenter/serveCenter';
    import { serveFileUpload,serveFileDelete} from '@/api/managementCenter/otherApi';
    export default {
        name: "evaluateDialog",
        components: {},
        props: [],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                show: false,
                loading: false,
                typeVoList:[],
                checkedTypeArr:[],
                filelist:[],
                form:{
                    score:5,
                    content:'',
                    privateFlag:1,
                    rationTypeIds:[],
                    serveId:'',
                    attach:''
                },
                rules: {
                    privateFlag: [
                        { required: true, message: "请选择公开状态", trigger: "change" }
                    ],
                    score: [
                        { required: true, message: "请选择服务满意度", trigger: "blur" }
                    ]
                }
            };
        },
        computed: {

        },
        mounted(){

        },
        methods: {
            beforeRemove(file) {
               if(!file.id){
                   return;
               }
                this.deleteFile(file.id,()=>{
                    this.filelist =this.filelist.filter(i=>{
                        return file.id!=i.id
                    })
                })
            },
            deleteFile(id,callback){
                serveFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        callback&&callback()
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            // 上传文件之前的方法
            beforeUpload(file){

                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                    return isLt2M
                }
                let fd = new FormData();
                fd.append('fromTarget',0)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                serveFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$message.success(  "上传文件成功!" );
                        this.filelist.push(
                            {
                                ...data.data,
                                name:data.data.fileName

                            }
                        )
                    }else{
                        this.$message.warning( data.msg|| "上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },
            // 获取评价查询列表
            getServeEvaluateTypeVoList (val,flag) {
                this.typeVoList=[];
                serveEvaluateTypeVoList({score:val+''}).then(({data})=> {

                    if(data.code == 0){
                        this.typeVoList=data.data||[];
                        this.checkedTypeArr=[];
                        if(flag){
                            this.checkedTypeArr=this.typeVoList.map(i=>i.id);
                        }

                    }
                }).catch(() => {

                });
            },
            rateChange(val){
                this.getServeEvaluateTypeVoList(val);
            },
            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitServeEvaluate()
                    } else {
                        return false;
                    }
                });
            },
            submitServeEvaluate(){
                this.loading = true;
                handleServeEvaluate(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code==0){
                        this.$message.success(  "评价成功!" );
                        this.$emit('saveSuccess')
                        this.show=false;
                    }else{
                        this.$message.warning(data.msg||"评价失败!" );
                    }

                }).catch(err=>{
                    this.$message.error(  (err&&err.message)||"服务器异常!" );
                    this.loading = false;
                })
            },
            // 显示弹框
            dialogShow(serveId) {

                this.show=true;
                this.form.serveId=serveId;
                this.form.score=5;
                this.getServeEvaluateTypeVoList(5,true);

            },


        },
        watch: {
            filelist(arr){
                if(arr.length){
                    this.form.attach=arr[0].id
                }else{
                    this.form.attach=""
                }
            },
            checkedTypeArr(val){
                this.form.rationTypeIds=val;
            },
            show(val){
                if(!val){
                    this.form.answer ='';
                    this.checkedTypeArr=[];
                    this.filelist=[];
                    this.form={
                            score:5,
                            content:'',
                            privateFlag:1,
                            rationTypeIds:[],
                            serveId:'',
                            attach:''
                    };
                }

            }

        },
        filters: {}
    };
</script>
<style lang="less">
    .evaluate-type{
        min-height: 96px;
        .el-checkbox__inner{
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 1px solid #ccc!important;

            &:after {
                height: 9px;
                left: 7px;
            }
        }
        .el-checkbox{
            &.is-checked{
                .el-checkbox__label{
                    color: #666!important;

                }

            }

        }
    }

</style>

